export default "__VITE_ASSET__24e384a2__"